import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import './AdminFormStyles.css';

interface FacebookPixelFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialData?: any;
  loading?: boolean;
}

const FacebookPixelFormModal: React.FC<FacebookPixelFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    pixel_id: '',
    is_active: true
  });
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        pixel_id: initialData.pixel_id || '',
        is_active: initialData.is_active !== undefined ? initialData.is_active : true
      });
    } else {
      setFormData({
        pixel_id: '',
        is_active: true
      });
    }
    setErrors({});
  }, [initialData, isOpen]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors((prev: any) => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors: any = {};
    
    if (!formData.pixel_id.trim()) {
      newErrors.pixel_id = 'Pixel ID is required';
    } else if (!/^\d+$/.test(formData.pixel_id.trim())) {
      newErrors.pixel_id = 'Pixel ID must contain only numbers';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={initialData ? 'Edit Facebook Pixel' : 'Add Facebook Pixel'}
      size="medium"
    >
      <form onSubmit={handleSubmit} className="admin-form-modal">
        <div className="admin-form-table">
          {/* Pixel ID */}
          <div className="admin-form-row">
            <div className="admin-form-label">Pixel ID *</div>
            <div className="admin-form-input">
              <input
                type="text"
                name="pixel_id"
                value={formData.pixel_id}
                onChange={handleChange}
                placeholder="e.g., 1234567890"
                className={errors.pixel_id ? 'has-error' : ''}
                disabled={loading}
              />
              {errors.pixel_id && <span className="error-text">{errors.pixel_id}</span>}
            </div>
          </div>

          {/* Active Status */}
          <div className="admin-form-row checkbox-row">
            <div className="admin-form-label">Status</div>
            <div className="admin-form-input">
              <label className="admin-toggle-label">
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                  disabled={loading}
                />
                <span>Active Pixel</span>
              </label>
              <span className="admin-form-hint">Enable tracking on your website</span>
            </div>
          </div>
        </div>

        <div className="admin-form-actions">
          <button
            type="button"
            className="btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-save"
            disabled={loading}
          >
            {loading ? 'Saving...' : (initialData ? 'Update' : 'Create')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default FacebookPixelFormModal;
